export default "__VITE_ASSET__BGphEP2U__"